import { PractitionerUpdatePermissionsCommand } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../translations';

import {
   PractitionerUpdatePermissionsFormBean,
   PractitionerUpdatePermissionsFormController,
} from './PractitionerUpdatePermissionsForm.types';

type PractitionerUpdatePermissionsModalConfirmButtonProps = Pick<
   PractitionerUpdatePermissionsFormController,
   'handleSubmit'
> & {
   readonly onUpdate: VoidFunction;
   readonly practitionerId: number;
};

export const PractitionerUpdatePermissionsModalConfirmButton = (
   props: PractitionerUpdatePermissionsModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: updatePractitionerPermissionsCommand } = useCqrsCommand<
      void,
      PractitionerUpdatePermissionsFormBean
   >(
      (parameters) => {
         const command = new PractitionerUpdatePermissionsCommand();
         command.id = props.practitionerId;
         command.addingMedicalData = parameters.addingMedicalData;
         command.medicalDataPreview = parameters.medicalDataPreview;
         command.conductingPreInterview = parameters.conductingPreInterview;
         return command;
      },
      {
         onSuccess: () => {
            props.onUpdate();
            dispatchSnackbarPositiveEvent(practitionersTranslationKeys.practitionerPermissionsUpdated);
         },
      }
   );

   return (
      <ModalConfirmButton
         label={commonTranslationKeys.save}
         onClick={props.handleSubmit(updatePractitionerPermissionsCommand)}
      />
   );
};
